import Resource from '@/api/core/resource'

class TipoEntidad extends Resource {
  constructor () {
    super('administracion/tipo-entidades')
  }
}

export default new TipoEntidad()
